fragment AccountSearchResult on Account {
    id
    type
    name: htmlName
    description
    initials
    htmlUrlPath
    avatarUrl
    primaryContact {
        name
    }
    phones {
        primary {
            value {
                numberFormatted
            }
        }
    }
    postalAddresses {
        primary {
            value {
                city
                postalCode
            }
        }
    }
}
